<div>
    <h5 class="text-start text-primary fw-bold ms-1 mt-4">RI Demat/Trading Account Details</h5>
    <p class="small mt-4">The data we collect serves only for the purpose of Account Cration, Management, Security and Fraud Prevention, Legal and Regulatory Compliances.</p>

    <div class="d-md-flex my-4">
        <div class="me-4 text-primary pt-2 mb-md-0 mb-3">
            <strong>Existing Demat Account</strong>
        </div>
        <div>
            <div class="input-group border w-md-60 form-floating">
                <button class="btn btn-outline-white dropdown-toggle border-0" type="button" (click)="dropToggle()" [ngClass]="selectedDPID ? '':'text-secondary'">{{selectedDPID ? selectedDPID : 'Select DP ID'}} </button>
                <ul class="dropdown-menu" [ngClass]="dpidToggle ? 'show':''">
                    <li *ngFor="let item of bankResponse; let i = index"><a class="dropdown-item" (click)="setDPID(i)">{{item.CLIENT_EXCH_ID}}</a></li>
                </ul>
                <input type="text" id="custid" class="form-control me-3 my-1  border-top-0 border-end-0  border-bottom-0 ps-3 pe-md-3 pe-1 py-0" readonly (input)="disableInput(dpIndex)" (paste)="(false)" placeholder="Customer ID" [(ngModel)]="customerID" autocomplete="off">
                <label for="custid" [ngClass]="selectedDPID ? '':'left'">{{selectedDPID ? 'DP ID & Customer ID' : 'Customer ID'}} <span class="text-danger">*</span></label>
            </div>
            <div *ngIf="customerIDError" class="ms-3 mt-2">
                <span class="small text-danger">Please Enter Customer ID</span>
            </div>
        </div>
    </div>

    <div *ngIf="existingRI" class="mb-5">
        <div class="mt-2 row">
            <div class="col-lg-6 col-12 d-flex">
                <input class="ms-0 form-check-input" type="radio" name="acStatus" id="convertDemat" [(ngModel)]="acStatus" value="convert" (change)="riError = false">
                <label class="form-check-label ps-2" for="convertDemat">Convert my existing demat account to NRI status</label>
            </div>
            <div class="col-lg-6 col-12 d-flex">
                <input class="ms-0 form-check-input" type="radio" name="acStatus" id="closeDemat" [(ngModel)]="acStatus" value="close" (change)="riError = false">
                <label class="form-check-label ps-2" for="closeDemat">I want to close my demat account and create a new one</label>
            </div>
        </div>
        <div class="mt-3" *ngIf="riError">
            <span class="text-danger">Please select any one option</span>
        </div>
        <div class="mt-3" *ngIf="acStatus === 'convert'">
            <p class="small"><strong><u>Note :</u></strong>
            <ul>
                <li class="small">If you have more than 1 demat accounts, only the one selected from the drop-down above will be converted. All other accounts will have to be closed. <span class="text-primary link" (click)="knowMore('conversion')">Know More...</span></li>
                <li class="small">If the demat account selected above is jointly held by 2 or more individuals, then signature for all be required </li>
                <li class="small">The mode of operation for the new demat account will be the same as the one that is being converted </li>
            </ul>
        </div>
        <div class="mt-3" *ngIf="acStatus === 'close'">
            <p class="small"><strong><u>Note :</u></strong>
            <p class="small">Currently we do not accept requests for demat closure digitally. <span class="text-primary link" (click)="knowMore('closure')">Know More...</span></p>
        </div>
    </div>

    <div *ngIf="!existingRI" class="mb-5">
        <div class="mt-2 row">
            <div class="col-lg-6 col-12 d-flex">
                <input class="ms-0 form-check-input" type="radio" name="acStatus" id="link" [(ngModel)]="acStatus" value="link" (change)="riError = false">
                <label class="form-check-label ps-2" for="link">Link my existing demat account</label>
            </div>
            <div class="col-lg-6 col-12 d-flex">
                <input class="ms-0 form-check-input" type="radio" name="acStatus" id="create" [(ngModel)]="acStatus" value="create" (change)="riError = false">
                <label class="form-check-label ps-2" for="create">Create a new demat account</label>
            </div>
        </div>
        <div class="mt-3" *ngIf="riError">
            <span class="text-danger">Please select any one option</span>
        </div>
    </div>

    <div class="d-md-flex mb-5">
        <div class="me-4 text-primary pt-2 mb-md-0 mb-3">
            <strong>Existing Trading Account</strong>
        </div>
        <div>
            <div class="form-floating mb-md-5 mb-4">
                <input type="text" id="tradingAcc" class="form-control text-uppercase" (paste)="(false)" (input)="disableInput(dpIndex)" readonly autocomplete="off" placeholder="Customer ID" [(ngModel)]="tradingAccNo" autocomplete="off">
                <label for="tradingAcc">Trading Account No <span class="text-danger">*</span></label>
            </div>
        </div>
    </div>
</div>

<div class="d-flex align-items-end  mx-0 mt-5 pt-5 row">
    <div class="col-6 p-0">
       <button class="btn btn-white border-primary text-primary px-4" (click)="backStage()">Back</button>
    </div>
    <div class="col-6 text-end p-0 pe-md-3">
        <button class="btn btn-primary px-4" [disabled]="!tradingAccNo" (click)="stageValidate()">Next</button>
    </div>
</div>
<ngx-ui-loader></ngx-ui-loader>
<app-error-modal #errorComp></app-error-modal>